export const SCOPE = 'bbraunBavReportingFeatureAdministration';
